import { render, staticRenderFns } from "./title-separator-cmp.vue?vue&type=template&id=2b31737b&scoped=true"
import script from "./title-separator-cmp.vue?vue&type=script&lang=js"
export * from "./title-separator-cmp.vue?vue&type=script&lang=js"
import style0 from "./title-separator-cmp.vue?vue&type=style&index=0&id=2b31737b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31737b",
  null
  
)

export default component.exports